import { baseApi as api } from './baseApi';

export type FeatureFlagMode = 'all' | 'none' | 'targeted';

export type AgentRole =
  | 'tenant_admin' | 'office_admin' | 'agent'
  | 'notary_sale' | 'notary_rent' | 'read_only';

export interface FeatureFlag {
  _id:           string;
  key:           string;
  label:         string;
  description?:  string;
  mode:          FeatureFlagMode;
  targetRoles:   AgentRole[];
  targetOffices: string[];
  targetUsers:   string[];
  updatedBy?:    string;
  createdAt:     string;
  updatedAt:     string;
}

export interface UpdateFeatureFlagDTO {
  label?:         string;
  description?:   string;
  mode?:          FeatureFlagMode;
  targetRoles?:   AgentRole[];
  targetOffices?: string[];
  targetUsers?:   string[];
}

export type ResolvedFlags = Record<string, boolean>;

export const featureFlagsApi = api.injectEndpoints({
  endpoints: (build) => ({

    getFeatureFlags: build.query<FeatureFlag[], void>({
      query: () => '/feature-flags',
      transformResponse: (r: any) => r.data,
      providesTags: ['FeatureFlag'],
    }),

    getResolvedFlags: build.query<ResolvedFlags, void>({
      query: () => '/feature-flags/resolved',
      transformResponse: (r: any) => r.data,
      providesTags: ['FeatureFlag'],
    }),

    updateFeatureFlag: build.mutation<FeatureFlag, { key: string; body: UpdateFeatureFlagDTO }>({
      query: ({ key, body }) => ({ url: `/feature-flags/${key}`, method: 'PUT', body }),
      transformResponse: (r: any) => r.data,
      invalidatesTags: ['FeatureFlag'],
    }),

    deleteFeatureFlag: build.mutation<void, string>({
      query: (key) => ({ url: `/feature-flags/${key}`, method: 'DELETE' }),
      invalidatesTags: ['FeatureFlag'],
    }),
  }),
});

export const {
  useGetFeatureFlagsQuery,
  useGetResolvedFlagsQuery,
  useUpdateFeatureFlagMutation,
  useDeleteFeatureFlagMutation,
} = featureFlagsApi;
